import cn from 'classnames';
import React, {FC} from 'react';

import {useAppSelector} from 'store/config/hooks';
import {EDraggableFrameType} from 'store/slices/draggable-frames-slice';
import {
    draggableFramesSelectors,
} from 'store/slices/draggable-frames-slice/draggable-frames-slice';

import {IDraggableFrameComponentProps} from './draggable-frame-types';
import {ApiRequestProgressFrame} from './frames/api-request-progress-frame';
import {TableReportAttachmentUploadFrame} from './frames/table-report-attachment-upload-frame';

interface IDraggableFrameRootProps {}

const DraggableFrameComponent: FC<IDraggableFrameComponentProps> = ({
    frameEntity,
}: IDraggableFrameComponentProps) => {
    const {type} = frameEntity;
    const Component = {
        [EDraggableFrameType.TableReportAttachmentUploadFrame]: TableReportAttachmentUploadFrame,
        [EDraggableFrameType.ApiRequestProgressFrame]: ApiRequestProgressFrame,
    }[type];
    return <Component frameEntity={frameEntity} />;
};

export const DraggableFrameRoot: FC<IDraggableFrameRootProps> = () => {
    const draggableFrames = useAppSelector(draggableFramesSelectors.selectAll);

    return (
        <div className={cn('draggable-frame-root')}>
            {draggableFrames.map(dFrame => (
                <DraggableFrameComponent
                    key={`${dFrame.type}_${dFrame?.id ?? 'no-id'}`}
                    frameEntity={dFrame}
                />
            ))}
        </div>
    );
};
